import { formatOdds } from '@/utils/format-odds';

import { SbkPromoCriterion } from '../../types';
import { getBetOddsById } from '../betslip-utils';
import { CriterionValidator } from './criterion-validators';

const getMinMultiplierValue = (criterion: SbkPromoCriterion) => Number(criterion.parameters?.VALUE);

export const minMultiplierCriterion: CriterionValidator = {
    // combined decimal odds, matching the backend's MinMultiplierCriterion
    validate: (criterion, state, betId) => {
        const minMultiplier = getMinMultiplierValue(criterion);
        return isNaN(minMultiplier) || getBetOddsById(state, betId) >= minMultiplier;
    },
    // any bet's odds can reach any threshold, so the promo is never permanently out of reach
    isVisibleForBet: () => true,
    translationKey: 'min_odds_required',
    getTranslationParams: (criterion, oddsFormat) => ({
        odds: formatOdds(oddsFormat, getMinMultiplierValue(criterion)),
    }),
};
